import { h } from 'preact'
import cx from '../../shared/classes'
import * as style from './style.css'

interface Props {
    disabled?: boolean
    primary?: boolean
    onClick?: () => void
}

const Button: preact.FunctionalComponent<Props> = ({
    children,
    disabled = false,
    primary = false,
    onClick = () => {},
}) => {
    return (
        <button
            {...(Boolean(disabled) ? { disabled: true } : {})}
            onClick={onClick}
            class={cx({
                [style.button]: true,
                [style.buttonPrimary]: primary,
            })}
        >
            {children}
        </button>
    )
}

export default Button
